import React from 'react';
import { Popup } from 'react-leaflet';
import { PotenzialKunde, PotenzialStatus } from '../types';
import { Icon } from './ui';

const STATUS_LABEL: Record<PotenzialStatus, string> = {
  NEU: 'Neu',
  KONTAKTIERT: 'Kontaktiert',
  ABGELEHNT: 'Abgelehnt',
  UMGEWANDELT: 'Kunde',
};

const STATUS_COLOR: Record<PotenzialStatus, string> = {
  NEU: 'bg-blue-100 text-blue-800',
  KONTAKTIERT: 'bg-yellow-100 text-yellow-800',
  ABGELEHNT: 'bg-red-100 text-red-800',
  UMGEWANDELT: 'bg-green-100 text-green-800',
};

interface Props {
  item: PotenzialKunde;
  onDetails?: () => void;
  onDelete: (id: number) => void;
}

const PotenzialPopup: React.FC<Props> = ({ item, onDetails, onDelete }) => {
  const adresse = [item.strasse, item.hausnummer].filter(Boolean).join(' ') || 'Adresse unbekannt';
  const ort = [item.plz, item.ort].filter(Boolean).join(' ');

  return (
    <Popup minWidth={200}>
      <div className="text-sm space-y-1">
        <div className="font-semibold text-gray-900">{adresse}</div>
        {ort && <div className="text-gray-500 text-xs">{ort}</div>}
        <div className="text-xs">Score: <strong>{item.scoreProzent?.toFixed(0)}%</strong></div>
        {item.flaecheFreiM2 != null && (
          <div className="text-xs text-gray-500">Freifläche: {Math.round(item.flaecheFreiM2)} m²</div>
        )}
        {item.bodenrichtwert != null && (
          <div className="text-xs text-gray-500">Bodenrichtwert: {Math.round(item.bodenrichtwert)} €/m²</div>
        )}
        <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_COLOR[item.status]}`}>
          {STATUS_LABEL[item.status]}
        </span>
        <div className="flex gap-1 pt-1">
          {onDetails && (
            <button
              onClick={(e) => { e.stopPropagation(); onDetails(); }}
              className="flex-1 px-3 py-1 bg-brand-600 text-white rounded text-xs hover:bg-brand-700">
              Details
            </button>
          )}
          <button
            onClick={(e) => { e.stopPropagation(); if (window.confirm(`Potenzial „${adresse}“ löschen?`)) onDelete(item.id); }}
            className="px-2 py-1 border border-red-300 text-red-600 rounded text-xs hover:bg-red-50"
            title="Potenzial löschen" aria-label="Potenzial löschen">
            <Icon.Trash className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default PotenzialPopup;
